import { render } from "./PathPage.vue?vue&type=template&id=7039d0fa"
import script from "./PathPage.vue?vue&type=script&lang=js"
export * from "./PathPage.vue?vue&type=script&lang=js"
script.render = render

export default script